import { Button, Col, Input, Popconfirm, Row, Space, Table, message } from "antd"
import React, { useState } from "react"
import PageHeader from "../../../components/Elements/PageHeader"
import { QuestionCircleFilled } from "@ant-design/icons"
import useFetchPriceRequests from "../../../store/Manager/useFetchPriceRequests"
import moment from "moment/moment"
import { Link } from "react-router-dom"
import { arrayUnion, doc, updateDoc } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { useAuthContext } from "../../../hooks/useAuthContext"
import RequestHistory from "../../../components/Admin/PriceRequest/RequestHistory"

const { TextArea } = Input

export default function PriceRequests() {
  const { user } = useAuthContext()

  const { loading: pricesLoading, priceRequests } = useFetchPriceRequests()
  const [cancelComment, setCancelComment] = useState("")

  const description = () => {
    return (
      <>
        <TextArea
          value={cancelComment}
          style={{ width: 300 }}
          onChange={(e) => setCancelComment(e.target.value)}
        />
      </>
    )
  }

  //remove request
  const removeRequest = async (data) => {
    const ref = doc(db, "priceCalculation", data.id)

    const newAdminRequest = {
      requestDate: new Date(),
      requestComment: cancelComment,
      requestedById: user.uid,
      requestedBy: user.email,
      role: "manager",
    }

    await updateDoc(ref, {
      adminRequested: true,
      adminRequestStatus: 3,
      adminRequests: arrayUnion(newAdminRequest),
    })
      .then(() => {
        message.success("Cancelled!")
      })
      .catch((err) => {
        message.error("Error!")
        console.error(err)
      })
  }

  const tableCols = [
    {
      title: "Client",
      dataIndex: "client",
      align: "center",
    },
    {
      title: "Product",
      dataIndex: ["product", "productName"],
      align: "center",
    },
    {
      title: "Requested By",
      // Removed dataIndex since we're going to compute the value dynamically
      render: (text, record) => {
        // Safely accessing the last admin request
        const lastAdminRequest =
          record.adminRequests && record.adminRequests.length > 0
            ? record.adminRequests[record.adminRequests.length - 1]
            : null

        // Return the last admin request's comment if it exists
        return lastAdminRequest ? lastAdminRequest.requestedBy : "no user"
      },
      align: "center",
    },
    {
      title: "Admin Comment",
      // Removed dataIndex since we're going to compute the value dynamically
      render: (text, record) => {
        // Safely accessing the last admin request
        const lastAdminRequest =
          record.adminRequests && record.adminRequests.length > 0
            ? record.adminRequests[record.adminRequests.length - 1]
            : null

        // Return the last admin request's comment if it exists
        return lastAdminRequest ? lastAdminRequest.requestComment : "No Comment"
      },
      align: "center",
    },
    {
      title: "Request Date",
      render: (text, record) => {
        // Assuming record.adminRequests contains your Firebase timestamp objects
        const lastAdminRequest =
          record.adminRequests && record.adminRequests.length > 0
            ? record.adminRequests[record.adminRequests.length - 1]
            : null

        // Convert Firebase timestamp to Moment.js date object and format it
        if (lastAdminRequest) {
          // Ensure 'requestDate' exists and has 'seconds'
          if (lastAdminRequest.requestDate && "seconds" in lastAdminRequest.requestDate) {
            // Convert seconds to milliseconds for Moment.js and format the date
            const formattedDate = moment(lastAdminRequest.requestDate.seconds * 1000).format(
              "DD.MM.YYYY"
            )
            return formattedDate
          }
        }

        return "No Date" // Fallback if no date is available
      },
      align: "center",
    },
    {
      title: "History",
      align: "center",
      render: (record) => {
        return <RequestHistory record={record} />
      },
    },
    {
      title: "Action",
      align: "center",
      render: (text, record) => {
        const updatedForState = {
          ...record,
          recalculation: true,
          adminRequest: true,
        }

        return (
          <>
            <Space>
              <Link state={updatedForState} to={`/calculations/`}>
                <Button type="primary" block>
                  Re-Calculate
                </Button>
              </Link>
              <Popconfirm
                title={"Enter cancel comment"}
                onConfirm={() => removeRequest(record)}
                placement="bottom"
                description={description}
                okText="Yes"
                cancelText="No">
                <Button danger>Remove</Button>
              </Popconfirm>
            </Space>
          </>
        )
      },
    },
  ]

  return (
    <div style={{ padding: 15 }}>
      <Row>
        <Col span={24}>
          <PageHeader text={"Requests from admin"} icon={<QuestionCircleFilled />} />
        </Col>
        <Col span={24}>
          <Table
            size="small"
            rowKey={(record) => record.id}
            loading={pricesLoading}
            dataSource={priceRequests}
            columns={tableCols}
          />
        </Col>
      </Row>
    </div>
  )
}
